export interface ISloganProps {
    text: string;
}

const Slogan: React.FC<ISloganProps> = ({ text }) => {
    return (
        <div className="mb-4 bg-yellow-50 rounded-[6px] p-[16px] text-blueGray-600 text-[14px] leading-[21px]">
            {text}
        </div>
    );
};

export default Slogan;
